import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

const StoreCtx = createContext(null);
export const useStore = () => useContext(StoreCtx);

export function StoreProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [cart, setCart] = useState({ items: [], subtotal_cents: 0, shipping_cents: 0, total_cents: 0, free_shipping_threshold_cents: 0 });
  const [cartOpen, setCartOpen] = useState(false);
  const [wishlist, setWishlist] = useState(() => {
    try { return JSON.parse(localStorage.getItem("hr_wishlist") || "[]"); } catch { return []; }
  });

  const cartId = useRef(localStorage.getItem("hr_cart_id") || "");
  if (!cartId.current) {
    cartId.current = (crypto.randomUUID ? crypto.randomUUID() : `c-${Date.now()}-${Math.random()}`);
    localStorage.setItem("hr_cart_id", cartId.current);
  }

  const refreshCart = useCallback(async () => {
    try { setCart(await api(`/cart/${cartId.current}`)); } catch { /* keep last cart */ }
  }, []);

  useEffect(() => {
    api("/settings").then(setSettings).catch(() => {});
    refreshCart();
  }, [refreshCart]);

  const addToCart = useCallback(async (productId, variantLabel = "", qty = 1) => {
    try {
      setCart(await api(`/cart/${cartId.current}/items`, { method: "POST", body: { product_id: productId, variant_label: variantLabel, qty } }));
      toast("Added to your cart — so cozy!", { style: { background: "#FCE7F3", color: "#2D2D2D", border: "1px solid #FBCFE8" } });
      setCartOpen(true);
    } catch (e) { toast.error(e.message); }
  }, []);

  const updateQty = useCallback(async (productId, variantLabel, qty) => {
    try { setCart(await api(`/cart/${cartId.current}/items`, { method: "PATCH", body: { product_id: productId, variant_label: variantLabel, qty } })); }
    catch (e) { toast.error(e.message); }
  }, []);

  const toggleWish = useCallback((slug) => {
    setWishlist((prev) => {
      const next = prev.includes(slug) ? prev.filter((s) => s !== slug) : [...prev, slug];
      localStorage.setItem("hr_wishlist", JSON.stringify(next));
      return next;
    });
  }, []);

  return (
    <StoreCtx.Provider value={{ settings, cart, cartId: cartId.current, refreshCart, addToCart, updateQty, cartOpen, setCartOpen, wishlist, toggleWish }}>
      {children}
    </StoreCtx.Provider>
  );
}
